import { useState, useEffect } from 'react';
import { getBanksNames } from '@services/funds-out-service';

export const useBankName = () => {
  const [bankNames, setBankNames] = useState([]);

  useEffect(() => {
    getBanksNames()
      .then((resp) => setBankNames(resp.message))
      // eslint-disable-next-line no-use-before-define
      .catch(() => setBankNames(banksMock));
  }, []);

  return {
    bankNames,
  };
};

const banksMock = [
  {
    finantial_institution_id: '028',
    finantial_institution_identifier: '97080000',
    finantial_institution_name: 'BANCO BICE',
  },
  {
    finantial_institution_id: '504',
    finantial_institution_identifier: '97032000',
    finantial_institution_name: 'BANCO BILBAO VIZCAYA ARGENTARIA, CHILE',
  },
  {
    finantial_institution_id: '055',
    finantial_institution_identifier: '99500410',
    finantial_institution_name: 'BANCO CONSORCIO',
  },
  {
    finantial_institution_id: '001',
    finantial_institution_identifier: '97004000',
    finantial_institution_name: 'BANCO DE CHILE - EDWARDS CITI',
  },
  {
    finantial_institution_id: '507',
    finantial_institution_identifier: '97051000',
    finantial_institution_name: 'BANCO DEL DESARROLLO',
  },
  {
    finantial_institution_id: '012',
    finantial_institution_identifier: '97030000',
    finantial_institution_name: 'BANCO ESTADO',
  },
  {
    finantial_institution_id: '051',
    finantial_institution_identifier: '96509660',
    finantial_institution_name: 'BANCO FALABELLA',
  },
  {
    finantial_institution_id: '009',
    finantial_institution_identifier: '97011000',
    finantial_institution_name: 'BANCO INTERNACIONAL',
  },
  {
    finantial_institution_id: '039',
    finantial_institution_identifier: '97041000',
    finantial_institution_name: 'BANCO ITAU',
  },
  {
    finantial_institution_id: '057',
    finantial_institution_identifier: '8388609',
    finantial_institution_name: 'BANCO PARIS',
  },
  {
    finantial_institution_id: '053',
    finantial_institution_identifier: '97947000',
    finantial_institution_name: 'BANCO RIPLEY',
  },
  {
    finantial_institution_id: '037',
    finantial_institution_identifier: '97036000',
    finantial_institution_name: 'BANCO SANTANDER - BANEFE',
  },
  {
    finantial_institution_id: '049',
    finantial_institution_identifier: '97053000',
    finantial_institution_name: 'BANCO SECURITY',
  },
  {
    finantial_institution_id: '016',
    finantial_institution_identifier: '97006000',
    finantial_institution_name: 'BCI - TBANC - NOVA',
  },
  {
    finantial_institution_id: '672',
    finantial_institution_identifier: '82878900',
    finantial_institution_name: 'COOPEUCH',
  },
  {
    finantial_institution_id: '027',
    finantial_institution_identifier: '97023000',
    finantial_institution_name: 'CORPBANCA',
  },
  {
    finantial_institution_id: '031',
    finantial_institution_identifier: '97951000',
    finantial_institution_name: 'HSBC BANK',
  },
  {
    finantial_institution_id: '729',
    finantial_institution_identifier: '76965737',
    finantial_institution_name: 'LOS HEROES',
  },
  {
    finantial_institution_id: '014',
    finantial_institution_identifier: '97018000',
    finantial_institution_name: 'SCOTIABANK',
  },
  {
    finantial_institution_id: '730',
    finantial_institution_identifier: '76967692',
    finantial_institution_name: 'TENPO Prepago',
  },
];
